export const getAuditLogTypeCategory = (type: string): string => {
  if (type.startsWith('server_')) return 'server'
  if (type.startsWith('storage_')) return 'storage'
  if (type.startsWith('user_')) return 'user'
  return 'org' // org spending limits and related actions
}

export const formatAuditLogType = (type: string) => {
  const words = type.split('_').filter(Boolean)
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export const getFormattedCategory = (type: string): string => {
  const category = getAuditLogTypeCategory(type)
  return category.charAt(0).toUpperCase() + category.slice(1)
}
